import { toast } from 'react-toastify';

export default function notify(type = "info", text) {
	return toast?.[type]?.(text)
}

